import { yupResolver } from "@hookform/resolvers/yup"
import { Box, Dialog, Grid, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { Button } from "components"
import { useState } from "react"
import { useForm } from "react-hook-form"
import * as Yup from "yup"
import { BtnSubmit, CloseBtn, Root, StyledContainer, Title } from "./styles"

interface IDialogEditProps {
  isOpen: boolean
  submit: (data: any) => void
  field: string
  title: string
  setIsOpen: (data: any) => void
  data: number
  defaultValue?: number
}

export const DialogEdit = ({
  submit,
  field,
  title,
  setIsOpen,
  isOpen,
  defaultValue,
}: IDialogEditProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const validateSchema = Yup.object().shape({
    [field]: Yup.string().required("Campo obrigatório"),
  })

  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(validateSchema),
  })

  const { errors } = formState

  const handleClose = () => {
    setIsOpen({
      isOpen: false,
      data: 0,
    })
  }

  const handleSubmitForm = async (data: any) => {
    setIsLoading(true)
    const value = Number(data[field])
    await submit(value)
    setIsLoading(false)
    handleClose()
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="sm">
      <Root>
        <StyledContainer>
          <Title>Editar configuração de {title.toLowerCase()}</Title>

          <CloseBtn onClick={handleClose}>
            <CloseIcon style={{ color: "#FF8C42" }} />
          </CloseBtn>

          <Box component="form" onSubmit={handleSubmit(handleSubmitForm)}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField
                  style={{ width: "100%" }}
                  error={!!errors?.[field]}
                  helperText={errors?.[field]?.message}
                  label={title}
                  variant="outlined"
                  type="number"
                  defaultValue={defaultValue || 0}
                  {...register(field)}
                />
              </Grid>
              <BtnSubmit>
                <Button type="submit" disabled={isLoading} variant="contained">
                  Opa, pode salvar!
                </Button>
              </BtnSubmit>
            </Grid>
          </Box>
        </StyledContainer>
      </Root>
    </Dialog>
  )
}
